<template>
  <div>
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="输入查询">
          <el-input size="small" v-model="searchForm.name" placeholder="请输入账号名称"></el-input>
        </el-form-item>
        <el-form-item label="阅读状态">
          <el-select size="small" v-model="searchForm.status" placeholder="请选择阅读状态">
            <el-option label="全部" value="0"></el-option>
            <el-option label="上架" value="10"></el-option>
            <el-option label="下架" value="20"></el-option>
          </el-select>
        </el-form-item>
         <el-form-item label="提交时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker size="small" v-model="searchForm.createTime" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="ID" label="用户ID" width="100">
      </el-table-column>
  
      <el-table-column prop="image" label="微信头像">
            <template slot-scope="scope">
              <div class="image-info">
                <div class="pic"><img v-img-url="scope.row.image" alt="" /></div>
              </div>
            </template>
          </el-table-column>
      <el-table-column prop="Nickname" label="微信昵称" width="100"></el-table-column>
      <el-table-column prop="account" label="姓名" width="100"></el-table-column>
   
      <el-table-column prop="phone" label="手机号" width="100"></el-table-column>
      <el-table-column prop="dailigrade" label="申请类型" width="100"></el-table-column>
      <el-table-column prop="address" label="申请加入的区域" width="150"></el-table-column>
     
      <el-table-column prop="createTime" label="提交时间"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="toupdate(scope.row)">已读</el-button>
          <el-button type="danger" size="small" @click="toedit(scope)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <div class="pagination">
      <el-pagination @current-change="handleCurrentChange" background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next" :total="totalDataNumber"></el-pagination>
    </div>
    <!--添加-->
    <Add v-if="open_add" :open_add="open_add" :addform="categoryModel" @closeDialog="closeDialogFunc($event, 'add')"></Add>
    <Edit v-if="open_add1" :open_add1="open_add1" :addform="categoryModel" :material_id="material_id" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>
  </div>
</template>

<script>
import materialApi from "@/api/material.js";


export default {
 
  data() {
    return {
      /*当前编辑的对象*/
      categoryModel: {
        catList: [],
        model: {}
      },
      /*是否打开添加弹窗*/
      open_add: false,
      open_add1: false,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 4,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        name: "",
        status:'',
        createTime:''
      },
      material_id: "",
      tableData: []
    };
  },
  created() {
    this.getData();
    this.getcate();
  },
  methods: {
    onSubmit() {
      this.curPage = 1;
      this.getData();
    },
    /*获取列表*/
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      self.loading = true;
      materialApi
        .productList(Params, true)
        .then(data => {
            let data1=[{
              ID:'110',
              account:"admin",
              image:'https://ruanchengspa.oss-accelerate.aliyuncs.com/2023092110301272d183183.png',
              password:'123456',
              Nickname:'张三',
              suppliername:'测试商家',
              dailigrade:'省代理',
              aboutID:'110',
              address:'杭州',
              aboutuser:'张三',
              phone:'13034565678',
              cate:'15',
              upname:'张三',
              upcate:'5',
              createTime:'2023-10-07 20:20:20'
            },{
              ID:'112',
              account:"admin",
              password:'123456',
              Nickname:'张三1',
              image:'https://ruanchengspa.oss-accelerate.aliyuncs.com/2023092110301272d183183.png',
              suppliername:'测试商家1',
              dailigrade:'城市代理',
              address:'上海',
              aboutID:'111',
              aboutuser:'张三1',
              phone:'13034565678',
              cate:'15',
              upname:'张三1',
              upcate:'5',
              createTime:'2023-10-07 20:20:20'
            },{
              ID:'113',
              account:"admin2",
              password:'123456',
              Nickname:'张三2',
              image:'https://ruanchengspa.oss-accelerate.aliyuncs.com/2023092110301272d183183.png',
              suppliername:'测试商家',
              dailigrade:'省代理',
              address:'杭州',
              aboutID:'112',
              aboutuser:'张三2',
              phone:'13034565678',
              cate:'15',
              upname:'张三1',
              upcate:'5',
              createTime:'2023-10-07 20:20:20'
            }]
          self.loading = false;
          self.tableData =data1;
          self.totalDataNumber = 3;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    getcate() {
      let self = this;
      materialApi
        .catList({}, true)
        .then(data => {
          console.log(data.data);
          self.categoryModel.catList = data.data.list;
          // self.categoryModel.catList = self.tableData;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*选择第几页*/
    handleCurrentChange(val) {},
    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      console.log(e, f);
      if (f == "add") {
        this.open_add = e.openDialog;
        if (e.type == "success") {
          this.getData();
        }
      }
      if (f == "edit") {
        this.open_add1 = e.openDialog;
        if (e.type == "success") {
          this.getData();
        }
      }
    },
    handleClick(row) {
      console.log(row);
    },
    /*打开添加*/
    addClick() {
      this.open_add = true;
    },
    toupdate(e) {
      console.log(e);
      this.material_id = e.material_id;
      this.open_add1 = true;
    },
    toedit(e) {
      console.log(e);
      let self = this;
      materialApi
        .delProduct(
          {
            material_id: e.row.material_id
          },
          true
        )
        .then(data => {
          self.$message({
            message: data.msg,
            type: "success"
          });
          self.getData();
        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>
<style lang="scss">
.image-info{
  width: 100px;
  height: 100px;
  .pic{
    width: 60px;
  height: 60px;
  image{
    width: 100%;
    height: 100%;
  }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/channel/apply/index.vue